import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import verified from '../../images/verified-blue.svg';

export default class SubscriptionOptions extends React.Component {

  static propTypes = {
    hasActiveSubscription: PropTypes.bool
  }

  render() {
    return (
      <div className='row subscription-options'>
        <div className='col-sm-6'>
          {this.renderUnlimited()}          
        </div>
        <div className='col-sm-6'>
          {this.renderFree()}
        </div>
      </div>
    );
  }

  renderFree() {
    const borderClass = (this.props.hasActiveSubscription) ? 'card border-dark' : 'card';
    const ctaClass = (this.props.hasActiveSubscription) ? 'btn btn-dark' : 'btn btn-outline-secondary';
    const ctaText = (this.props.hasActiveSubscription) ? 'Be Free' : 'Stay Free';
    const ctaLink = (this.props.hasActiveSubscription) ? '/subscription/cancel' : '/account';

    return (
      <div className={ borderClass }>
        <div className="card-body" data-behavior='free-plan'>
          <h5 className="card-title">Free for One</h5>
          <h6 className="card-subtitle mb-2 text-muted">$0.00</h6>
          <div className="card-text">
            <ul>
              <li>One word at a time</li>
              <li>A queue after that</li>
              <li>But it's free</li>
            </ul>
          </div>
          <div className='action'>
            <Link to={ ctaLink } className={ ctaClass }>{ ctaText }</Link>
          </div>
        </div>
      </div>
    );
  }

  renderUnlimited() {
    const borderClass = (this.props.hasActiveSubscription) ? 'card' : 'card border-dark';
    const ctaClass = (this.props.hasActiveSubscription) ? 'btn btn-outline-secondary' : 'btn btn-dark';
    const ctaText = (this.props.hasActiveSubscription) ? 'Stay Unlimited' : 'Go Unlimited';
    const ctaLink = (this.props.hasActiveSubscription) ? '/account' : '/subscription';

    return (
      <div className={ borderClass }>
        <div className="card-body" data-behavior='unlimited-plan'>
          <h5 className="card-title">
            Unlimited
            <span className='verified-mark-15-inline'>
              <img src={verified} alt='Verified and Unlimited' />
            </span>            
          </h5>
          <h6 className="card-subtitle mb-2 text-muted">${process.env.REACT_APP_SUBSCRIPTION_FEE} per month.</h6>
          <div className="card-text">
            <ul>
              <li>As many words as you want</li>
              <li>No queue</li>
              <li>Super easy to cancel</li>
              <li>Mnemonic images for words</li>
              <li>
                <span className='verified-mark-15-inline'>
                  Get a cool badge
                  (<img src={verified} alt='Verified and Unlimited' />)
                </span>
              </li>
            </ul>
          </div>
          <div className='action'>
            <Link to={ ctaLink } className={ ctaClass }>{ ctaText }</Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/subscription_options.jsx